<template>
    <div>
        <div class="accordion accordion-toggle-arrow" id="userFilter">
            <div class="card" style="overflow:inherit">
                <div class="card-header bg-transparent" id="headingOne">
                    <div aria-controls="filterForm" class="card-title collapsed"
                         data-target="#filterForm"
                         data-toggle="collapse">
                        {{ $t('label.search') }}
                    </div>
                </div>
                <kt-panel>
                    <div aria-labelledby="filterForm" class="collapse" data-parent="#userFilter" id="filterForm">
                        <div class="card-body">
                            <form @submit.prevent="filterAction($event, query)">
                                <kt-form-section>
                                    <kt-form-row>
                                        <kt-col class="mb-2" md="3" sm="3" xs="12">
                                            <label for="type"
                                                   v-text="$t('label.type')"
                                            >
                                            </label>
                                            <select id="type" class="form-control" name="type" v-model="query.type"
                                            >
                                                <option v-for="(item, index) in transmitType" :key="index" :value="item.value" :selected="item.value === null" v-text="item.title"
                                                ></option>
                                            </select>
                                        </kt-col>
                                        <kt-col class="mb-2" md="3" sm="3" xs="12">
                                            <label for="bank_account"
                                                   v-text="$t('label.bank_account')"
                                            >
                                            </label>
                                            <select class="form-control" id="bank_account" name="bank_account"
                                                    v-model="query.iban">
                                                <option :value="null" selected v-text="$t('label.default')"
                                                ></option>
                                                <option :key="index" :value="account.number"
                                                        v-for="(account, index) in saman_banks"
                                                        v-text="account.number + ' (' + account.fa_name + ')'"
                                                >
                                                </option>
                                            </select>
                                        </kt-col>
                                        <kt-col class="mb-2" md="3" sm="3" xs="12">
                                            <label for="description"
                                                   v-text="$t('label.description')"
                                            >
                                            </label>
                                            <select id="description" class="form-control" name="description" v-model="query.description"
                                            >
                                                <option :value="null" selected v-text="$t('label.all_types')"
                                                ></option>
                                                <option :value="transmitDescription.reversal"
                                                        v-text="transmitDescriptionStr.get(transmitDescription.reversal)"
                                                ></option>
                                            </select>
                                        </kt-col>
                                        <kt-col class="mb-2" md="3" sm="3" xs="12">
                                            <label for="from_date"
                                                   v-text="$t('label.amount')"
                                            >
                                            </label>
                                            <input
                                                id="amount"
                                                class="form-control"
                                                name= "query.amount"
                                                v-model="query.amount"
                                                 />
                                        </kt-col>
                                        <kt-col class="mb-2" md="3" sm="3" xs="12">
                                            <label for="from_date"
                                                   v-text="$t('label.ref_num')"
                                            >
                                            </label>
                                            <input
                                                id="ref_num"
                                                class="form-control"
                                                name= "query.ref_num"
                                                v-model="query.ref_num"
                                                 />
                                        </kt-col>
                                        <kt-col class="mb-2" md="3" sm="3" xs="12">
                                            <label for="from_date"
                                                   v-text="$t('label.payment_id')"
                                            >
                                            </label>
                                            <input
                                                id="ref_num"
                                                class="form-control"
                                                name= "query.ref_num"
                                                v-model="query.payment_id"
                                                 />
                                        </kt-col>
                                        <kt-col class="mb-2" md="3" sm="3" xs="12">
                                            <label for="from_date"
                                                   v-text="$t('label.from_date')"
                                            >
                                            </label>
                                            <button id="reset_from_date"
                                                    @click="clearFromDate"
                                                    type="button"
                                                    class=" btn btn-label-danger trash-btn"
                                            >
                                                <i class="la la-trash-o"></i>
                                            </button>
                                            <datePicker
                                                format="YYYY-MM-DD HH:mm:ss"
                                                display-format="dddd jDD jMMMM jYYYY HH:mm"
                                                input-class="form-control"
                                                id="from_date"
                                                :max="query.to_date"
                                                name= "query.from_date"
                                                v-model="query.from_date"
                                                type="datetime" />
                                        </kt-col>
                                        <kt-col class="mb-2" md="3" sm="3" xs="12">
                                            <label for="to_date"
                                                   v-text="$t('label.to_date')"
                                            >
                                            </label>
                                            <button id="reset_from_date"
                                                    @click="clearToDate"
                                                    type="button"
                                                    class=" btn btn-label-danger trash-btn"
                                            >
                                                <i class="la la-trash-o"></i>
                                            </button>
                                            <datePicker
                                                format="YYYY-MM-DD HH:mm:ss"
                                                display-format="dddd jDD jMMMM jYYYY HH:mm"
                                                input-class="form-control"
                                                id="to_date"
                                                :min="query.from_date"
                                                name= "query.to_date"
                                                v-model="query.to_date"
                                                type="datetime" />
                                        </kt-col>
                                    </kt-form-row>
                                    <kt-row>
                                        <kt-col xs="12" sm="6" md="6" class="mt-4">
                                            <input type="submit" class="btn btn-success btn-wide" :value="$t('label.filter')">
                                        </kt-col>
                                    </kt-row>
                                </kt-form-section>
                            </form>
                        </div>
                    </div>
                    <div class="line-divider my-3"></div>
                    <kt-panel-body>
                        <kt-datatable ref="datatable" v-bind="datatableProps">
                        </kt-datatable>
                    </kt-panel-body>
                </kt-panel>
            </div>
        </div>
    </div>
</template>

<script>
import {i18n} from "@/plugins/i18n";
import $ from "jquery";
import {ApiUrl, walletService} from "@/common/api.service";
import {transmitDescription, transmitDescriptionStr} from "@/constants/transmitDescription";
import {AuthorizationHeader} from "@/common/jwt.service";
import samanColumns from "@/views/wallets/AyandeWallets/Admin/components/statements/columns/saman-columns";

export default {
    name: "saman",
    props: {
        fetch_starshop: {
            default: false,
            type: Boolean
        },
        api_base_path: {
            default: ApiUrl.path(''),
            type: String
        }
    },
    computed: {
        datatableProps() {
            return {
                id: 'saman_statement_report_datatable',
                data: {
                    type: 'remote',
                    source: {
                        read: {
                            url: this.api_base_path + 'wallet/common/admin/get-saman-statements',
                            method: 'GET',
                            headers: AuthorizationHeader,
                            map: res => {
                                return res.data.data;
                            },
                            params: {
                                query: this.query,
                            },
                        }
                    },
                    pageSize: 10,
                    serverPaging: true,
                    serverFiltering: true,
                    serverSorting: true,
                },
                layout: {},
                pagination: false,
                sortable: true,
                columns: samanColumns,
            }
        },


        transmitDescription() {
            return transmitDescription
        },
        transmitDescriptionStr() {
            return transmitDescriptionStr
        }
    },
    data() {
        return {
            transmitType: [
                {title: i18n.t('label.all_types'), value: null},
                {title: i18n.t('label.credit'), value: 'CREDIT'},
                {title:  i18n.t('label.debit'), value: 'DEBIT'},
            ],
            saman_banks:[],
            query: {
                type: null,
                description: null,
                iban: null,
            },
        }
    },
    mounted() {
        const samanBankAccounts = this.fetch_starshop
            ? walletService.getStarShopAllWalletSamanBanks
            : walletService.getAllWalletSamanBanks;

        samanBankAccounts().then(res => {
            this.saman_banks = res.data.data.all_saman_bank_accounts;
        });
    },

    methods: {
        clearFromDate() {
            if(this.query.from_date) {
                this.query.from_date = null
            }
        },
        clearToDate() {
            if(this.query.to_date) {
                this.query.to_date = null
            }
        },
        filterAction(e, query) {

            this.query = query;

            if (this.$refs.datatable.KTDatatable) {
                this.$refs.datatable.reload();
            }
        },

    }
}
</script>

<style scoped>

</style>